import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'

export default function createSeparator(): PopoverProperty {
  return {
    label: 'separator',
    value: '',
    id: Math.random().toString(),
  }
}
